export default __webpack_public_path__ + "static/icon-a996d3a583358d5fb8ed33061931cca5.png";